module.exports = __webpack_public_path__ + "media/images/global/btn_close-d978b0c6c0ab1e22317233a1de1ce54c.png";